import React, { createContext, FC, useCallback, useContext, useState } from 'react'

// Where the cellular banners go on the page. The prompt is mounted once in the
// private layout, above every page, so its dialogs work everywhere; its banner bar
// belongs under the page's title bar, like the trial and other page banners. A page
// title bar renders <BannerSlot />, and Banner portals into it. With no slot on the
// page the banner stays where the prompt is mounted, at the top.

interface SlotState {
  slot: HTMLElement | null
  setSlot: (el: HTMLElement | null) => void
}

const SlotContext = createContext<SlotState>({ slot: null, setSlot: () => undefined })

export const BannerSlotProvider: FC = ({ children }) => {
  const [slot, setSlot] = useState<HTMLElement | null>(null)
  return <SlotContext.Provider value={{ slot, setSlot }}>{children}</SlotContext.Provider>
}

export const useBannerSlot = (): HTMLElement | null => useContext(SlotContext).slot

// Rendered under a page title bar. Registers itself while mounted.
export const BannerSlot: FC = () => {
  const { setSlot } = useContext(SlotContext)
  const ref = useCallback((el: HTMLDivElement | null) => setSlot(el), [setSlot])
  return <div
    data-testid='cellular-banner-slot'
    ref={ref}
  />
}
